(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'public',
            url: '/',
            redirectTo: 'buscador',             // Redireccion al buscador simple
            data: {
                pageTitle: 'global.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'ctrl'
                }
            }
        })
        ;
    }
})();
